<template>
<span class="menu-item">
    <a
        :href="item.url"
        :target="item.aTarget || '_blank'"
        class="menu-item-name"
        :style="{width: item.width,  backgroundColor: item.bgColor, color: item.color}"
        :data-type="item.name"
    >
        {{item.name}}
        <template v-if="!!item.childs">
            <img src="../assets/other/down.svg" class="menu-item-name-img">
        </template>
    </a>

    <div class="menu-item-popup"  v-if="!!item.childs" :style="{width: item.width}">
        <template v-for="child in item.childs">
            <a
                :href="child.url"
                :target="child.aTarget || '_blank'"
                :key="child.name"
                class="popup-item"
                :data-type="`${item.name}-${child.name}`"
            >
                {{child.name}}
            </a>
        </template>
    </div>
</span>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    width: {
      type: String,
      default: 'auto'
    },
    item: {
      type: Object,
      required: true
    }
  }
};
</script>
<style scoped>
.menu-item {
  position: relative;
  margin-left: 6px;
  display: inline-block;
  margin-top: 14px;
}
.menu-item-name,
.menu-item .popup-item {
  padding: 8px 10px;
  box-sizing: border-box;
  height: 36px;
  background: #474747;
  font-weight: 500;
  color: #D9DCDF;
  font-size: 13px;
  border: none;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
}
.menu-item-name:hover,
.menu-item .popup-item:hover {
  background-color: #333;
  opacity: 0.9;
}
.menu-item-name {
  border-radius: 4px;
}
.menu-item-name-img {
  position: absolute;
  right: 10px;
  width: 20px;
  height: 20px;
  float: right;
}
.menu-item-name:hover + .menu-item-popup {
  display: flex;
}
.menu-item-popup {
  display: none;
  position: absolute;
  z-index: 100;
  flex-direction: column;
  border-radius: 4px;
  background: #474747;
  border: 1px solid #474747;
  top: 36.5px;
  left: 0;
}
.menu-item-popup:hover {
  display: flex;
}

</style>
